const initialState = { promoCodeInputDisplay: false };

const systemSettings = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_PROMO_CODE_INPUT_DISPLAY':
            return {
                ...state,
                promoCodeInputDisplay: action.payload,
            };
        default:
            return state;
    }
};

export default systemSettings;
